/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import applications from './modules/applications';
import auth from './modules/auth';
import companies from './modules/companies';
import companyapplications from './modules/companyapplications';
import createAccessProviderModule from '@produtos/store-access-provider';
import createSettingProviderModule from '@produtos/store-setting-provider';
import databaseLoopbackTransformer from '@i9box/vuelib/src/utils/datatable-loopback-transformer';
import modaldelete from './modules/modaldelete';
import modaldopup from './modules/modalpopup';
import users from './modules/users';
import userversions from './modules/userversions';
import versions from './modules/versions';
import versionsdefault from './modules/versionsdefault';
import vuelib from '@vuelib/store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // padrão vuelib
    vuelib,

    // padrão aplicação
    app,
    auth,

    // provider
    settingProvider: createSettingProviderModule(),
    accessProvider: createAccessProviderModule({
      domainAction: 'settingProvider/$setup',
      pinGetter: 'settingProvider/pin',
      fetchAllAdapter: databaseLoopbackTransformer,
    }),

    applications,
    versions,
    companies,
    companyapplications,
    modaldopup,
    modaldelete,
    userversions,
    users,
    versionsdefault,
  },
});
/* eslint-enable */
